document.addEventListener('DOMContentLoaded', async () => {
  const body = document.getElementById('js-promos-body');

  try {
    const { promos, birthdayPromo } = await window.SKAuth.apiFetch('/api/promo/list');
    const rows = [];

    if (birthdayPromo) {
      const active = !birthdayPromo.expiresAt || new Date(birthdayPromo.expiresAt) >= new Date();
      rows.push(renderRow(birthdayPromo.code, 'День народження', birthdayPromo.expiresAt, active));
    }

    promos.forEach(p => {
      const active = !p.endsAt || new Date(p.endsAt) >= new Date();
      rows.push(renderRow(p.code, p.purpose, p.endsAt, active));
    });

    if (!rows.length) {
      body.innerHTML = '<p class="profile-empty">Промокодів поки немає</p>';
    } else {
      body.innerHTML = rows.join('');
    }
  } catch (err) {
    body.innerHTML = `<p class="profile-msg profile-msg--error">${err.message}</p>`;
  }
});

function renderRow(code, purpose, endsAt, isActive) {
  const dateLabel = endsAt ? `до ${formatDate(endsAt)}` : '—';
  const statusClass = isActive ? 'promo-status--active' : 'promo-status--used';
  const statusLabel = isActive ? 'Активний' : 'Використаний';

  return `
    <div class="promos-row${isActive ? '' : ' promos-row--used'}">
      <span class="promos-col promos-col--code">${code}</span>
      <span class="promos-col promos-col--purpose">${purpose}</span>
      <div class="promos-col promos-col--date">
        <span class="promo-date">${dateLabel}</span>
        <span class="promo-status ${statusClass}">${statusLabel}</span>
      </div>
    </div>
  `;
}

function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('uk-UA', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}
